import React from 'react';

const KeyValueEditor = ({ entries = [], onChange, t}) => {
    const handleChange = (index, field, value) => {
        const updated = [...entries];
        updated[index][field] = value;
        onChange(updated);
    };

    const handleAdd = () => {
        onChange([...entries, { key: '', value: '' }]);
    };

    const handleRemove = (index) => {
        const updated = [...entries];
        updated.splice(index, 1);
        onChange(updated);
    };

    return (
        <div>
            <button type="button" className="btn btn-secondary" onClick={handleAdd}>
                {t('Add New Entry')}
            </button>
            <table className="table mt-2">
                <thead>
                <tr>
                    <th>#</th>
                    <th>Key</th>
                    <th>Value</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {entries.map((entry, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                                <textarea
                                    className="form-control"
                                    value={entry.key}
                                    placeholder="Key"
                                    rows={1}
                                    onChange={(e) => handleChange(index, 'key', e.target.value)}
                                />
                        </td>
                        <td>
                                <textarea
                                    className="form-control"
                                    value={entry.value}
                                    placeholder="Value"
                                    rows={1}
                                    onChange={(e) => handleChange(index, 'value', e.target.value)}
                                />
                        </td>
                        <td>
                            <button
                                type="button"
                                className="btn btn-danger"
                                onClick={() => handleRemove(index)}
                            >
                                {t('Delete')}
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            <button type="button" className="btn btn-secondary" onClick={handleAdd}>
                {t('Add New Entry')}
            </button>
        </div>
    );
};

export default KeyValueEditor;
